import React, { useEffect, useState } from "react";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import SettingCard from "../../component-lib/Molecules/setting-card/SettingCard";
import { accountManagement, communications, master } from "./constants";
import {
  accountManagementIcon,
  communicationIcon,
  masterIcon,
} from "../../assets";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { componentKey, setAdminUsersList } from "./SettingsSlice";
import ViewMyAccountDialog from "./dialogs/MyAccount-Dialog/ViewMyAccountDialog";
import ChangePasswordDialog from "./dialogs/ChangePasswordDialog";
import { changePassword } from "../login-screen/LoginSaga";
import {
  componentKey as authComponentKey,
  setCloseChangePasswordDialog,
  setIsLoggedIn,
} from "../login-screen/LoginSlice";

const SettingsScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { closeChangePasswordDialog } = useSelector(
    (state: any) => state[authComponentKey]
  );

  const [showAdminProfile, setShowAdminProfile] = useState(false);
  const [openChangePasswordDialog, setOpenChangePasswordDialog] =
    useState(false);

  useEffect(() => {
    if (closeChangePasswordDialog) {
      setOpenChangePasswordDialog(false);
      dispatch(setCloseChangePasswordDialog(false));
      localStorage.clear();
      sessionStorage.clear();
      dispatch(setIsLoggedIn(false));
      window.location.href = "/login";
    }
  }, [closeChangePasswordDialog]);

  const handleChangePassword = (formData: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }) => {
    dispatch(
      changePassword({
        oldPassword: formData.currentPassword,
        newPassword: formData.newPassword,
        confirmNewPassword: formData.confirmPassword,
      })
    );
  };

  return (
    <WrapperCard customClasses="m-3 p-3 flex-1 min-h-0">
      <div className="flex flex-col h-full gap-3">
        <div className={`flex items-center justify-between w-full`}>
          <Heading title={"Settings"} customStyle={{ color: "#1D1D1D" }} />
        </div>
        <div className="flex gap-4">
          <SettingCard
            title="Account Management"
            imgIcon={accountManagementIcon}
            menuItems={accountManagement}
            handleClick={(value) => {
              dispatch(setAdminUsersList({}));
              switch (value) {
                case "myAccount":
                  //navigate("/settings/account-management/user-profile");
                  setShowAdminProfile(true);
                  break;
                case "changePassword":
                  setOpenChangePasswordDialog(true);
                  break;
                case "adminUser":
                  navigate("/settings/account-management/admin-user", {
                    state: { user: "Admin" },
                  });
                  break;
                case "providerUser":
                  navigate("/settings/account-management/user/provider-user", {
                    state: { user: "Provider" },
                  });
                  break;
                case "staffUser":
                  navigate("/settings/account-management/user/staff-user", {
                    state: { user: "Staff" },
                  });
                  break;
                case "roles":
                  navigate("/settings/account-management/roles");
                  break;
                case "rRes":
                  navigate(
                    "/settings/account-management/roles-and-responsibility"
                  );
                  break;
                default:
                  console.log("Unhandled value:", value);
                  break;
              }
            }}
          />
          <SettingCard
            title="Master"
            imgIcon={masterIcon}
            menuItems={master}
            handleClick={(value) => {
              console.log("value-22:", value);
              switch (value) {
                case "dataImport":
                  navigate("/settings/master/data-import");
                  break;
                case "drugCatalogue":
                  navigate("/settings/master/drug-catalogue");
                  break;
                case "icd10Code":
                  navigate("/settings/master/icd-10-code", {
                    state: { code: "ICD 10 Code" },
                  });
                  break;
                case "dsmCode":
                  navigate("/settings/master/dsm-code", {
                    state: { code: "DSM Code" },
                  });
                  break;
                case "orderStatus":
                  navigate("/settings/master/order-status");
                  break;
                case "orderTypes":
                  navigate("/settings/master/order-types");
                  break;
                case "taskType":
                  navigate("/settings/master/task-type");
                  break;
                case "incidentLocation":
                  navigate("/settings/master/incident-location");
                  break;
                case "primaryTreatingClinician":
                  navigate("/settings/master/primary-treating-clinician");
                  break;
                case "unitDesignation":
                  navigate("/settings/master/unit-designation");
                  break;
                default:
                  console.log("Unhandled value:", value);
                  break;
              }
            }}
          />
          <SettingCard
            title="Communications"
            imgIcon={communicationIcon}
            menuItems={communications}
            handleClick={(value) => {
              switch (value) {
                case "emailTemplate":
                  navigate("/settings/communications/email-template", {
                    state: { template: "Email" },
                  });
                  break;
                case "smsTemplate":
                  navigate("/settings/communications/sms-template", {
                    state: { template: "SMS" },
                  });
                  break;
                case "notesTemplate":
                  navigate("/settings/communications/notes-template", {
                    state: { template: "Discharge Instructions" },
                  });
                  break;
                case "communicationRule":
                  navigate("/settings/communications/communication-rule");
                  break;
                default:
                  console.log("Unhandled value:", value);
                  break;
              }
            }}
          />
        </div>
        {showAdminProfile && (
          <ViewMyAccountDialog
            //dialogHeading="View Inventory Details"
            handleClose={() => setShowAdminProfile(false)}
            //inventoryData={defaultDataForInventory}
            isOpen={showAdminProfile}
          />
        )}
        {openChangePasswordDialog && (
          <ChangePasswordDialog
            isOpen={openChangePasswordDialog}
            handleClose={() => setOpenChangePasswordDialog(false)}
            handleChangePassword={handleChangePassword}
          />
        )}
      </div>
    </WrapperCard>
  );
};

export default SettingsScreen;
